import { QueryTable } from "@/components/query-table/QueryTable";
import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { useTranslation } from "react-i18next";
import { useContractorAssignmentsList } from "../hooks/useContractorAssignmentsList";
import { ContractorPlannedHoursService } from "../contractorPlannedHoursService";
import { readContractorPlannedHours } from "@/schemas/contractorPlannedHours";
import { useState } from "react";
import { useContractorData } from "../hooks";
import { useFormatters } from "@/lib/hooks/useFormatters";
import { DetailField } from "@/components/DetailField";
import { InsetWell } from "@/components/InsetWell";

interface ContractorPlannedHoursListProps {
  contractorId: string;
}

export const ContractorPlannedHoursList = ({
  contractorId,
}: ContractorPlannedHoursListProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const contractor = useContractorData();
  const { formatDateTime, formatNumber } = useFormatters();

  const { query, filteredOptions } = useContractorAssignmentsList({
    name: "contractorPlannedHours",
    service: ContractorPlannedHoursService,
    contractorId,
    enabled: isOpen,
    sorting: [{ id: "period", desc: false }],
  });

  return (
    <CollapsibleSection
      title={t("contractors.plannedHours.title")}
      description={t("contractors.plannedHours.description")}
      defaultOpen={false}
      scrollIntoViewOnOpen
      onOpenChange={setIsOpen}
    >
      <InsetWell>
        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <DetailField
            label={t("contractors.fields.planned_hours_approved_at")}
          >
            {formatDateTime(contractor.planned_hours_approved_at)}
          </DetailField>
          <DetailField
            label={t("contractors.fields.planned_hours_approved_value")}
          >
            {formatNumber(contractor.planned_hours_approved_value)}
          </DetailField>
        </dl>
      </InsetWell>
      <QueryTable
        schema={readContractorPlannedHours}
        name="contractorPlannedHours"
        translationKey="contractorPlannedHours"
        query={query}
        options={filteredOptions}
      >
        <QueryTable.Menubar>
          <QueryTable.Menubar.Columns />
          <QueryTable.Menubar.Settings />
        </QueryTable.Menubar>
        <DataTableQueryContextProvider value={{ query }}>
          <QueryTable.Content isInDialog>
            <QueryTable.Status />
          </QueryTable.Content>
        </DataTableQueryContextProvider>
      </QueryTable>
    </CollapsibleSection>
  );
};
